import { useEffect, useRef } from 'react'

/**
 * Smooth-scroll the window to the top when user-visible error state changes.
 *
 * Pass a string that identifies the current error (message text, or a stable key).
 * Pass `null`, `undefined`, or whitespace-only when there is no error so the hook
 * resets and the next error triggers another scroll.
 */
export function useScrollToTopOnErrorSignal(signal: string | null | undefined): void {
  const prevActive = useRef<string | null>(null)

  useEffect(() => {
    const trimmed =
      signal !== undefined && signal !== null ? String(signal).trim() : ''
    const active = trimmed === '' ? null : trimmed

    if (active === null) {
      prevActive.current = null
      return
    }

    if (active === prevActive.current) {
      return
    }

    prevActive.current = active
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [signal])
}
